import { Component, HostListener, signal, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { handleImageError } from 'shared-ui/utils';

@Component({
  selector: 'shared-gallery-dialog',
  templateUrl: './gallery-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GalleryDialogComponent {
  dialog = inject<MatDialogRef<GalleryDialogComponent>>(MatDialogRef);

  onImgError = handleImageError;
  namespace = signal('');
  gallery = signal<string[]>([]);
  selected = signal(0);

  constructor() {
    const data = inject<{
      namespace: string;
      gallery: string[];
      index?: number;
    }>(MAT_DIALOG_DATA);

    this.namespace.set(data.namespace);
    this.gallery.set(data.gallery);
    this.selected.set(data?.index ?? 0);
  }

  close(): void {
    this.dialog.close(true);
  }

  left() {
    this.selected.update(i => (i > 0 ? i - 1 : i));
  }

  right() {
    this.selected.update(i => (i < this.gallery().length - 1 ? i + 1 : i));
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') {
      this.left();
    } else if (event.key === 'ArrowRight') {
      this.right();
    } else if (event.key === 'Escape') {
      this.close();
    }
  }
}
